import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@els/els-react--button';

function Footer({ onActivationConfirm = () => null }) {
  return (
    <div className="els-btn-group-right remote-access-dialog__footer">
      <Button
        data-e2e="remote-access-email-continue"
        type="primary"
        size="small"
        onClick={onActivationConfirm}
        className="e2e-remote-access-email-continue">
        Got it
      </Button>
    </div>
  );
}

Footer.propTypes = {
  onActivationConfirm: PropTypes.func,
};

export default Footer;
